<template>
  <form @submit.prevent="onSubmit">
    <div class="sm:grid sm:grid-cols-2 sm:gap-5">
      <div class="mb-5">
        <label
          for="newsletterName"
          class="text-gray-700 font-extrabold italic font-title uppercase mb-2 text-12"
        >
          Name
        </label>
        <input
          type="text"
          class="border border-purple-200 px-4 py-2 block w-full rounded text-purple-900"
          v-model="name"
          placeholder="Your name..."
          required
        />
        <error-message
          :errors="getErrors('name')"
          error-classes="my-2 bg-red-400 text-blue-extradark rounded p-2"
        ></error-message>
      </div>

      <div class="mb-5">
        <label
          for="newsletterEmail"
          class="text-gray-700 font-extrabold italic font-title uppercase mb-2 text-12"
        >
          Email
        </label>
        <input
          type="email"
          class="border border-purple-200 px-4 py-2 block w-full rounded text-purple-900"
          v-model="email"
          placeholder="Your email address..."
          required
        />
        <error-message
          :errors="getErrors('email')"
          error-classes="my-2 bg-red-400 text-blue-extradark rounded p-2"
        ></error-message>
      </div>
    </div>

    <div class="sm:grid sm:grid-cols-2 sm:gap-5">
      <div class="mb-5">
        <label
          for="newsletterSubject"
          class="text-gray-700 font-extrabold italic font-title uppercase mb-2 text-12"
        >
          Subject
        </label>
        <select
          name="subject"
          id="newsletterSubject"
          class="border border-purple-200 px-4 py-2 block w-full rounded text-purple-900"
          v-model="subject"
          required
        >
          <option :value="null">Please select...</option>
          <option value="Gym Consultancy">Gym Consultancy</option>
          <option value="Gym Design">Gym Design</option>
          <option value="Podcast Query">Podcast Query</option>
          <option value="Marketing / Branding">Marketing / Branding</option>
          <option value="Other">Other</option>
        </select>
      </div>
    </div>

    <div class="mb-5">
      <label
        for="newsletterMessage"
        class="text-gray-700 font-extrabold italic font-title uppercase mb-2 text-12"
      >
        Message
      </label>
      <textarea
        name="message"
        id="newsletterMessage"
        v-model="message"
        cols="30"
        rows="4"
        class="border border-purple-200 px-4 py-2 block w-full rounded text-purple-900"
        placeholder="Your message to us..."
        required
      ></textarea>
    </div>

    <div class="text-center mt-2">
      <div v-if="xhrMessage" class="my-4 p-4 bg-hotpink text-purple-900 rounded text-left">
        {{ xhrMessage }}
      </div>
      <button
        type="submit"
        class="button w-full sm:w-auto sm:min-w-280 md:min-w-360"
        :disabled="sending"
      >
        {{ buttonText }}
      </button>
    </div>
  </form>
</template>

<script>
import HandleXHRErrors from '../mixins/HandleXHRErrors';
import ErrorMessage from './ErrorMessage.vue';

export default {
  mixins: [HandleXHRErrors],
  components: {
    ErrorMessage,
  },
  data() {
    return {
      sending: false,
      complete: false,
      name: '',
      email: '',
      subject: null,
      message: '',
    };
  },
  computed: {
    buttonText() {
      if (this.sending) {
        return 'Sending...';
      }

      if (this.complete) {
        return 'Sent!';
      }

      return 'Sign up';
    },
  },
  methods: {
    resetForm() {
      this.name = '';
      this.email = '';
      this.subject = null;
      this.message = '';
    },

    onSubmit() {
      this.resetXhrErrors();
      this.sending = true;

      console.log('sendiong...');

      axios
        .post('/newsletters', {
          type: 'contactform',
          name: this.name,
          email: this.email,
          subject: this.subject,
          message: this.message,
        })
        .then(() => {
          this.complete = true;
          this.resetForm();

          window.setTimeout(() => {
            this.complete = false;
          }, 4000);
        })
        .catch(this.handleAxiosValidationErrors)
        .catch((err) => {
          this.xhrMessage = 'There was a problem when sending your contact form. Please try again.';
        })
        .then(() => {
          this.sending = false;
        });
    },
  },
};
</script>
